module.exports = __webpack_public_path__ + "static/Temp-Project-BG-153b47a6c6480065c8ccdb3123c788b9.jpg";